module.exports = __webpack_public_path__ + "static/media/fi.02b56319.svg";